@if (showPanel) {
    <agpr-panel
        [header]="field.label"
        [paddingBottom]="field.paddingBottom"
    >
        <div class="agpr-blockForm">
            <ng-template #formFieldsContainer></ng-template>
        </div>
    </agpr-panel>
}

